import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Routes, Route } from 'react-router-dom';
import { Theme } from '@mui/styles';
import AppView from '~common/components/app-view/index';
import FormBasedEditor from '~common/form/form-based-editor';
import URLManager from '~common/lib/url-manager';



import DefinitionDataProvider from "~common/form/icg-definition-data-provider";
import FormBasedContainer from "~common/form/form-based-container-fc";
import {ContainerTypeEditor} from "~common/form/form-based-container-fc";

const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	history: any;
}

type State = {};

class ExternalLinkEditor extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {};
	}

	UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {}

	render() {

    const {match} = this.props;
		const { classes }: { classes: ClassNameMap } = this.props;

		var criteria = URLManager.getQueryString(window.location.href)

		return (
			<div className={classes.container}>
				<AppView history={this.props.history}>
					<DefinitionDataProvider>
						<FormBasedContainer
							containerType={ContainerTypeEditor} 
							history={this.props.history} 
							match={match}
							clearDataOnSubmit={false}
							dataUrl="/api/links"
							allowDelete={true}
							confirmDeleteMessage={"Are you sure you want to delete this link?"}
							formSelector={{"formType": "externalLinkEditor", "userType": "Internal"}}
							successMessage="ExternalLink Successfully Saved"
							returnURL={`/links/admin?q=${URLManager.getQueryStringValue(criteria)}`}
						>
						</FormBasedContainer>
					</DefinitionDataProvider>
				</AppView>
			</div>
		);
	}
}

export default withStyles(styles)(ExternalLinkEditor);
